module.exports = __webpack_public_path__ + "static/media/ecosup.dc9ced46.png";